import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#DA001A',
        accent: '#805B80',
        info: '#6EA3BF',
        error: '#E68F24',
        success: '#1C6662',
        warning: '#A3A04D',
      },
    },
  },
});
